import { IMetaCommand } from "../../../../common/services/cqs/commandManager";

export class InvalidateAvtalCommand implements IMetaCommand {
    $type = "InvalidateAvtalCommand";
    avtalGuid: string;
    avtalId: number;
    rowVersion: string;

    get key() {
        return this.avtalGuid;
    }

    constructor(guid: string, id: number, rowVersion: string) {
        this.avtalGuid = guid;
        this.avtalId = id;
        this.rowVersion = rowVersion;
    }
}
